import authManage from "@/middlewares/manage/auth";
import selectOrganization from "@/middlewares/manage/select-organization";

export default {
  path: "payment-plans",
  name: "PaymentPlanManage",
  component: () =>
    import(
      /* webpackChunkName: "payment-plan-manage-layout-view" */ "@/views/Manage/PaymentPlan/LayoutView.vue"
    ),
  redirect: { name: "PaymentPlanSearch" },
  children: [
    {
      path: "",
      name: "PaymentPlanSearch",
      component: () =>
        import(
          /* webpackChunkName: "payment-plan-manage-searching-view" */ "@/views/Manage/PaymentPlan/FilterSearching.vue"
        ),
      meta: {
        middleware: [authManage, selectOrganization],
      },
    },
    {
      path: "create", // /manage/payment-plans/create
      name: "PaymentPlanCreate",
      component: () =>
        import(
          /* webpackChunkName: "payment-plan-manage-create-view" */ "@/views/Manage/PaymentPlan/Create.vue"
        ),
      meta: {
        middleware: [authManage, selectOrganization],
      },
    },
    {
      path: "edit/:id", // /manage/payment-plans/edit/1
      name: "PaymentPlanEdit",
      component: () =>
        import(
          /* webpackChunkName: "payment-plan-manage-edit-view" */ "@/views/Manage/PaymentPlan/Edit.vue"
        ),
      meta: {
        middleware: [authManage, selectOrganization],
      },
    },
  ],
};
